var getCustomerId = function() {
	try {
		let curr = window.ShopifyAnalytics.meta.page.customerId;
		if (curr !== undefined && curr !== null && curr !== "") {
			return curr;
		}
	} catch(e) { }
	try {
		let curr = window.meta.page.customerId;
		if (curr !== undefined && curr !== null && curr !== "") {
			return curr;
		}
	} catch (e) { }    
	try {
		let curr = _st.cid;
		if (curr !== undefined && curr !== null && curr !== "") {
			return curr;
		}
	} catch (e) { }
	try {
		let curr = ShopifyAnalytics.lib.user().traits().uniqToken;
		if (curr !== undefined && curr !== null && curr !== "") {
			return curr;
		}
	} catch (e) { }
	
	return "dev"; // null // 8260134994184
	
}

function watchDog(shopifyCustomerID, eventID, logData) {
	
	
	// For debugging purposes
	const watchDogData = JSON.stringify({ 
		customer_id: shopifyCustomerID,
		event: eventID,
		data: logData 		
	});
	
	console.log(watchDogData);
	
	fetch('https://n8n.thulin.consulting/webhook/77b56e6d-758f-4724-8b32-a557bf95ddb3', {
		method: 'POST',
		headers: {
				'Content-Type': 'application/json'
		},
		body: watchDogData
	})
	.then(response => response.json())
	.then(data => {		
		console.log(data);                          
	})
	.catch(error => {
		console.error('Error:', error);
	});
}

// Always reference the real global
const nav = globalThis.navigator;

// Make your own namespace instead of mutating `navigator`
window.debugUA = (function(){
	const ua = nav?.userAgent || "";
	let tem;
	let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	if (/trident/i.test(M[1])) {
		tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
		return 'IE ' + (tem[1] || '');
	}
	if (M[1] === 'Chrome') {
		tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
		if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
	}
	M = M[2] ? [M[1], M[2]] : [nav.appName, nav.appVersion, '-?'];
	if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
	return M.join(' ');
})();

const browser = window.debugUA;



function cartClear(callback){
	
	// clear the cart items
	$.ajax({
		type: "POST",
		url: '/cart/clear.js',
		data: '',
		dataType: 'json',
		success: function(cart) {		
			localStorage.removeItem('missingTeeth');
			if(callback) callback();

		},
		error: function(XMLHttpRequest, textStatus) {
			/* error code */
		}
	});
}


let cartClearInFlight = null;

function cartClearOnce() {
	if (cartClearInFlight) return cartClearInFlight;

	cartClearInFlight = new Promise((resolve, reject) => {
		try {
			cartClear(() => resolve());
		} catch (e) {
			reject(e);
		}
	}).finally(() => {
		setTimeout(() => { cartClearInFlight = null; }, 1500); // cool-down
	});

	return cartClearInFlight;
}
